export const phrases = {
  heading_settings_sort: "De personeelslijst sorteren",
  body_settings_sort: "Sorteer de personeelslijst op voor- of achternaam.",
  since_o_clock: "Sinds {time} klok",
  old_data_warning_my_area: "We konden geen nieuwe informatie laden. Zorg ervoor dat je verbonden bent met het internet.",
  no_data_warning_my_area: "Zorg ervoor dat u verbonden bent met het internet en probeer het opnieuw.",
  no_data_available_my_area: "Er kunnen geen gegevens worden geladen",
  last_update_data: "Laatst bijgewerkt",
  something_went_wrong_absences: "Er is iets misgegaan. Probeer het later nog eens.",
  something_went_wrong_with_the_pin_entry: "Er ging iets mis met de PIN-invoer...",
  pin_must_be_four_digits: "De PIN-code moet uit precies vier cijfers bestaan.",
  pins_do_not_match: "De ingevoerde pincodes komen niet overeen.",
  pin_is_not_numerical: "De PIN-code mag alleen uit cijfers bestaan.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Stamp eruit",
  finish_break: "Einde pauze",
  finish_loading_time: "Einde laadtijd",
  finish_driving_time: "Einde rijtijd",
  finish_business_trip: "Einde diensttijd",
  finish_project_as_task: "Project beëindigen",
  finish_special_one: "Einde special1",
  finish_special_two: "Einde Special2",
  you_clockout: "Je stampt jezelf eruit",
  sentence_work_time: "Je bent aan het werk. | Je werkt nu.",
  sentence_break: "Je neemt een pauze. | Je neemt een pauze.",
  sentence_loading_time: "Je neemt momenteel de laadtijd op. Hauruck! | U neemt momenteel de laadtijd op. Eikel!",
  sentence_business_trip: "Dienst aangemeld. Veel plezier!",
  sentence_driving_time: "Je boekt rijtijd. Riemen vast en gaan! | Je boekt reistijd. Riemen vast en gaan!",
  sentence_special_one: "U boekt Special 1. | U boekt special 1.",
  sentence_special_two: "U boekt Special 2. | U boekt special 2.",
  sentence_custom_time: "U boekt.",
  you_are_booked_in_activity: "Je stempelt {activity}! | Je stempelt {activity}!",
  substitute_warning: "{ days } Bij afwezigheid van dagen of meer moet een vervanger worden aangewezen.",
  substituted_by: "Vertegenwoordigd door",
  name_clocked_in: "{name} gestempeld",
  /************************************/
  //Signature stuff:

  signature: "Handtekening",
  please_sign: "Gelieve te ondertekenen",
  signature_with_date: "Handtekening van {date}",
  signature_with_date_with_name: "Handtekening van {date} van {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Handtekening van {date} van {name} in {location}",
  signature_with_name: "Handtekening van {name}",
  signature_with_name_with_location: "Handtekening van {name} in {location}",
  signature_with_location: "Handtekening in {location}",
  /*************************************/

  accept_terms_and_conditions: "Door het formulier te versturen accepteert u onze {agb} en onze {datenschutzerklaerung}.",
  what_is_your_name: "Hoe heet je?",
  your_email: "Uw e-mailadres",
  what_is_your_company_name: "Wat is de naam van uw bedrijf?",
  what_do_you_want_to_do_with_clockin: "Wat wil je met clockin doen?",
  almost_finished: "Ik ben er bijna.",
  test_clockin_for_amount_period: "Test clockin {amountOfDaysTestPeriod} een paar dagen gratis!",
  code_needed_to_connect: "Gebruik uw code",
  you_have_no_company_code: "Heeft u geen code? Neem contact op met de persoon in uw bedrijf.",
  connect_your_device: "Sluit uw apparaat aan!",
  please_type_in_device_id: "Voer de apparaat-ID in, die u kunt vinden onder mobiele apparaten op onze website.",
  new_at_clockin: "Nieuw bij de klok?",
  pin_repeat: "Herhaal PIN",
  configure_your_pin: "Stel uw 4-cijferige PIN in",
  configure_your_pin_text: "U heeft de PIN nodig om toegang te krijgen tot uw persoonlijke ruimte op de tablet terminal.",
  congratulations: "Gefeliciteerd!",
  start_now: "Begin nu",
  device_name_info: "U kunt de apparaatnaam van uw mobiele apparaat wijzigen, zodat u meerdere apparaten kunt volgen. Voorbeeld: \"Smartphone MaxMustermann\". De naam kan ook later worden gewijzigd.",
  select_project: "Selecteer project",
  select_time: "Selecteer tijd",
  create_new_account: "Nieuw account aanmaken",
  join_my_company: "Sluit je aan bij mijn bedrijf",
  join_clockin_with_qr: "Aanmelden met QR-code",
  change_project: "Veranderingsproject",
  my_messages: "Mijn nieuws",
  my_documents: "Mijn documenten",
  my_data_and_passwords: "Mijn gegevens en wachtwoorden",
  my_account_data: "Mijn gegevens",
  change_my_password: "Wachtwoord wijzigen",
  forgot_password: "Ik weet mijn wachtwoord niet.",
  open_camera: "Open camera",
  scan_now: "Nu scannen",
  sync_now: "Nu synchroniseren",
  clear_logs: "Lege logboeken",
  saveAndGoBack: "Opslaan en terugkeren",
  full_day: "Hele dag",
  activate_scanner: "Scanner is geactiveerd",
  scanner_is_inactive: "Scanner inactief",
  change_project_by_scan_qr: "Scan de QR-code van het project waarnaar u wilt overschakelen.",
  scan_device_by_qr: "Scan de QR-code van het apparaat dat u wilt gebruiken.",
  no_access_to_camera_please_connect_device_manually: "Helaas kon de camera niet worden geopend, voer de apparaatcode handmatig in.",
  no_access_to_camera_please_clockin_manually: "Helaas was er geen toegang tot de camera mogelijk, stempel handmatig in.",
  qr_code_login: "QR-code registratie",
  scan_to_login: "Scan uw QR-code om in te loggen.",
  checklist_was_saved: "Checklist werd opgeslagen",
  question_save_changes_short: "Wijzigingen opslaan?",
  question_save_changes: "Wilt u de wijzigingen opslaan?",
  question_delete_checklist_short: "Checklist verwijderen?",
  question_delete_checklist: "Weet je zeker dat je de controlelijst wilt verwijderen?",
  checklist_is_sending: "Checklist wordt toegestuurd",
  checklist_sent_successfully: "Checklist succesvol 🎉 verzonden",
  checklist_could_not_be_sent: "Checklist kan niet worden verzonden, probeer het later opnieuw.",
  checklist_transmission_problems_in_the_past: "In het verleden zijn er overdrachtsproblemen geweest met sommige bestanden.",
  checklist_send_with_potential_data_loss: "Wil je proberen de checklist zonder deze bestanden te versturen?",
  documentation_is_sending: "De projectdocumentatie wordt verzonden",
  documentation_sent_successfully: "Projectdocumentatie succesvol verzonden 🎉",
  confirm_documentation_dismissal: "Wil je de documentatie echt weggooien?",
  discard_unsaved_changes: "Wil je je veranderingen weggooien?",
  documentation_will_be_sent_when_online: "De documentatie wordt verzonden zodra je weer online bent.",
  confirmation_is_sending: "De projectbevestiging wordt verzonden",
  ask_for_geo_permission: "Deze app heeft je locatie nodig, " + "maar heeft daar geen toestemming voor.\n\n" + "Wilt u de instellingen openen?",
  all_projects: "Alle projecten",
  half_day: "Halve dag",
  start_end: "Volgens de tijd",
  my_area: "Mijn gebied",
  my_area_video_teaser_clockin_explained_by_frederik: "klok uitgelegd door Freddi",
  add_time: "Tijd creëren",
  show_times_in_confirmation: "Showtijden in bevestiging",
  change_time: "Wijzigingstijd",
  finish_project: "Volledig project",
  finish_project_date: "Afspraak afronden",
  unfinish_project: "Project heropenen",
  unfinish_project_date: "Heropen afspraak",
  absence_overview: "Beheer van afwezigheden",
  edit_absence: "Wijziging afwezigheid",
  edited_absence: "Afwezigheid bewerkt",
  created_absence: "Verlofaanvraag succesvol aangemaakt",
  creating_absence: "Je verlofaanvraag is nu aangemaakt",
  error_creating_absence: "Fout bij het maken van het afwezigheidsverzoek",
  create_absence: "Verzuim creëren",
  deleted_absence: "Verzoek om afwezigheid ingetrokken",
  new_request: "Nieuwe toepassing",
  your_requests: "Uw toepassingen",
  planned_days: "Geplande dagen",
  planned_hours: "Geplande uren",
  used_days: "Gebruikte dagen",
  used_hours: "Uren besteed",
  free_days: "Vrije dagen",
  free_hours: "Vakantie-uren",
  open_days: "Open dagen",
  open_hours: "Openingsuren",
  withdraw_request: "Aanvraag intrekken",
  change_request: "Verzoek tot wijziging",
  request_was_approved: "Uw aanvraag werd goedgekeurd",
  request_is_pending: "Uw aanvraag is nog niet goedgekeurd",
  request_was_rejected: "Uw aanvraag is afgewezen",
  add_attachment: "Bijlage toevoegen",
  message_optional: "Bericht (optioneel)",
  filed_on: "Ingediend op",
  this_year: "Dit jaar",
  search_sub_projects: "Aan welk deelproject wilt u werken?",
  error_occurred: "Er is een fout opgetreden, probeer het later opnieuw.",
  re_record: "Deze video verwijderen en opnieuw opnemen?",
  delete_video: "Opname verwijderen?",
  no_results_found: "Geen resultaten gevonden",
  record_again: "Opnieuw",
  request_valid_email: "Voer een geldig e-mailadres in.",
  request_valid_company_name: "Voer een geldige bedrijfsnaam in.",
  request_valid_first_name: "Voer een geldige voornaam in.",
  request_valid_last_name: "Voer een geldige achternaam in.",
  total_duration_today: "Totale tijd vandaag",
  show_daily_protocol: "Toon dagelijks logboek",
  change_profile_pic: "Profielfoto wijzigen",
  logout_account: "Account verbreken",
  you_are_working: "Je bent nu aan het werk!",
  you_are_taking_a_break: "Je hebt pauze!",
  activity_edited: "Activiteit bewerkt",
  activity_edited_undo: "Verwerking succesvol ongedaan gemaakt",
  activity_edited_missing_project: "Oh, het project ontbreekt nog steeds!",
  activity_deleted: "Activiteit verwijderd",
  activity_deleted_undo: "Verwijderde activiteit hersteld",
  activity_created: "Nieuwe activiteit aangemaakt",
  activity_created_undo: "Nieuw aangemaakte activiteit ingetrokken",
  correct_working_hours: "Correcte werktijden",
  your_changes_are_being_saved: "Uw wijzigingen zijn nu opgeslagen.",
  manage_working_hours: "Beheer van werktijden",
  delete_activity: "Activiteit verwijderen",
  start_navigation: "Navigatie starten",
  no_valid_email: "Het ingevoerde e-mailadres is niet geldig.",
  delete_checklist: "Checklist verwijderen",
  active_checklists: "Actieve controlelijsten",
  scan_qr_code: "Scan QR-code",
  switch_to_office_center: "Schakel over naar het kantoorcentrum",
  confirm_project_completion_short: "Volledig project",
  confirm_project_date_completion_short: "Afspraak afronden",
  project_completed: "Project voltooid!",
  project_date_completed: "Afspraak definitief!",
  confirm_project_uncompletion_short: "Project heropenen",
  confirm_project_date_uncompletion_short: "Heropen afspraak",
  project_uncompleted: "Project geactiveerd",
  project_date_uncompleted: "Datum geactiveerd",
  choose_project: "Selecteer project",
  choose_sub_project: "Selecteer subproject",
  choose_site: "Selecteer locatie",
  active_projects: "Actieve projecten",
  completed_term: "ingevuld",
  completed_projects: "Voltooide projecten",
  end_of_work: "Fijne avond.",
  correct_time: "Juiste tijd",
  you_stamp_x: "Je stempelt",
  enter_pin: "Voer PIN-code in",
  wrong_pin: "Verkeerde PIN invoer",
  pin_change_required: "U wordt gevraagd uw PIN-code te wijzigen",
  enter_new_pin: "Nieuwe PIN-code invoeren",
  approve_pin: "Bevestig PIN",
  no_projects_scheduled: "Voor {day} Er worden geen projecten opgeslagen.",
  you_clock_in_project: "Je registreert de werktijd van het project vanaf nu.",
  project_scan_error: "Deze code is voor geen enkel project geldig.",
  show_more_days: "toon meer dagen",
  show_more_times: "Toon meer tijden",
  only_show_today: "Toon alleen vandaag",
  todays_total_time: "Totale tijd vandaag",
  everything_synced: "Je gegevens zijn up-to-date!",
  upload_in_progress: "De gegevens worden geüpload...",
  who_are_you: "Wie ben je?",
  is_uploading_to_server: "Uw wijzigingen worden overgebracht naar het kantoorcentrum.",
  offline_and_data_is_stored_locally: "Uw wijzigingen worden binnenkort doorgegeven aan het kantoorcentrum. ",
  show_more: "meer tonen",
  activity_edited_wrong_date: "U heeft de verkeerde datum ingevoerd.",
  confirm_logout: "Wilt u zich echt uitschrijven?",
  confirm_clockout: "Weet je zeker dat je wilt uitklokken voor vandaag?",
  gps_is_active: "GPS-gegevens worden verzonden",
  location_tracking_is_active: "GPS-tracering inschakelen.",
  app_settings: "App instellingen",
  clock_reminder: "Postzegel - Herinnering",
  mon_to_fri: "Standaard: Maandag - vrijdag",
  logout: "Account verbreken",
  refresh: "Update",
  prompt_language_settings: "Stel hier de taal van de app in.",
  prompt_clock_reminder: "Herinnering via pushmelding om je dagelijkse werk aan te passen.",
  register_company: "Registreer bedrijf",
  use_code: "Gebruik code",
  our_customers: "Onze klanten",
  free_test_now: "Test nu gratis",
  tier_attendance: "Ik registreer alleen werkuren en pauzes.",
  tier_documentation: "Ik wil ook werkuren boeken op projecten die ik beheer in clockin.",
  your_tier: "Uw pakket",
  all_clockin_functions: "Alle inklokfuncties",
  checklists_formulars: "Checklists en functies",
  projectfile_incl_chat: "Digitale projectbestanden (incl. chat)",
  photo_sketch_note: "Foto-, schets- en notitiefunctie",
  digital_signature: "Digitale handtekeningen",
  datev_connection: "DATEV aansluiting",
  calendar_absences: "Agenda en afwezigheden beheren",
  individual_design: "Individuele uitstraling",
  attendance_time_tracking: "Stationaire tijdregistratie via tabletterminal",
  mobile_time_tracking: "Mobiele tijdregistratie via smartphone app",
  browser_time_tracking: "Browser tijdregistratie op de PC voor thuiskantoor",
  help_use_code: "Voer de code in die u vindt in het kantoorcentrum onder mobiele apparaten/medewerkers.",
  wrong_code: "Verkeerde code",
  wrong_code_text: "De code is niet geldig. Probeer het opnieuw met een geldige code",
  wrong_code_text_short: "De code is ongeldig",
  clockin_logo: "Clockin-logo",
  invalid_qr_code: "Ongeldige QR-code",
  invalid_qr_code_text: "De gescande QR-code is niet geldig. Scan een geldige klokcode.",
  code_already_connected: "Met deze code kun je verbinding maken met je apparaat. Maar je bent al verbonden.",
  wrong_credentials: "Onjuiste toegangsgegevens",
  wrong_credentials_text: "De e-mail- en wachtwoordcombinatie die u hebt opgegeven, kon niet worden gevonden. Controleer uw invoer en probeer het opnieuw.",
  new_pin: "Nieuwe PIN-code invoeren",
  choose_next_action: "Kies uw volgende actie",
  name_of_software_package: "Naam van het softwarepakket",
  select_teamleader: "Wie stempelt er voor het team?",
  select_teamleader_description: "Om door te gaan met stempelactiviteiten, selecteer je een persoon die de machine nu overneemt.",
  clocked_in_on_this_device: "Gestempeld op deze eenheid",
  not_clocked_in_on_this_device: "Niet afgestempeld op dit apparaat",
  select_new_teamleader: "Wie moet er nu stempelen voor het team?",
  switch_teamleader: "Eenheid overhandigen",
  just_me: "Gewoon uitklokken",
  select_the_new_teamleader: "Bepaal de nieuwe teamleider",
  back_to_selection: "terug naar de selectie",
  manage_team: "Team beheren",
  total_time_team: "Totale tijd van het team",
  count_members_clocked_in: "{clockedin}/{members} Teamleden gestempeld in",
  whole_team: "Het hele team",
  teammembers_still_clockedin: "Kiezen of je alleen jezelf wilt uitklokken of iedereen in het team?",
  clockout_all: "Stamp alle",
  select_employee: "Selecteer eerst een gebruiker",
  something_went_wrong: "Er is iets misgegaan, probeer het later nog eens.",
  new_pin_successfully_changed: "PIN succesvol gewijzigd",
  enter_pin_before_clockin_prompt: "Voer eerst één voor één uw pincode in om in te klokken.",
  enter_pin_before_clockout_prompt: "Voer eerst één voor één uw pincode in om uit te klokken.",
  delete_activity_alert_title: "Activiteit verwijderen",
  delete_activity_alert_msg: "Weet je zeker dat je de activiteit wilt verwijderen?",
  delete_absence_message: "Weet u zeker dat u de aanvraag wilt intrekken?",
  delete_absence_title: "Aanvraag intrekken",
  are_you_sure: "Weet je het zeker?",
  request_password: "Nieuw wachtwoord aanvragen",
  password_requested: "Er is een link voor een nieuw wachtwoord naar je e-mailadres gestuurd.",
  no_email_retrieved: "Geen e-mail ontvangen? Controleer uw spam-map of probeer het opnieuw.",
  name_of_customer: "Naam van de klant",
  missing_permissions_homepage_text: "Je hebt geen toestemming om je activiteit op deze machine te wijzigen. Neem contact op met uw beheerder om toegang te krijgen.",
  no_permission_warning_my_area: "Je hebt geen toegang tot dit gebied. Neem contact op met je beheerder om toegang te krijgen.",
  employee_clocked_in: "{name} geregistreerd!",
  employee_clocked_out: "{name} afgemeld!",
  no_employee_to_qr_code_warning: "Voor deze QR-code kon geen medewerker worden gevonden.",
  no_employees_registered_heading: "Er is nog geen personeel toegewezen aan deze eenheid.",
  no_employees_registered_body: "In het kantoorcentrum in de instellingen voor mobiele apparaten kun je medewerkers toewijzen die dan hun tijden op dit apparaat mogen registreren.",
  no_employee_found: "Helaas kon niemand met deze naam worden gevonden.",
  no_employee_assigned: "Geen werknemer toegewezen",
  you_need_help: "Heb je hulp nodig?",
  here_you_can_get_help_to_register_employees_for_device: "Hier vind je alle informatie over het toewijzen van personeel aan een eenheid.",
  show_time: "Tijd creëren",
  export_timesheet: "Urenstaat exporteren",
  select_month: "Selecteer maand",
  internet_connection_required: "Hiervoor is een internetverbinding vereist.",
  select_an_activity_to_clockin_your_team: "Selecteer een activiteit om te stempelen in je team.",
  confirm_uploading_sqlite_for_debugging: "Weet je zeker dat je de gegevens wilt uploaden in de app voor Clockin-ondersteuning?",
  no_tasks_available: "Geen taken beschikbaar",
  click_to_add_tasks: "Klik om taken toe te voegen",
  scan_nfc_tag: "Houd uw kaart tegen de lezer.",
  link_nfc_tag: "NFC-tag koppelen",
  select_employee_for_nfc_tag: "Selecteer een medewerker om deze NFC-tag te koppelen:",
  nfc_tag_linked_successfully: "NFC-tag succesvol met {name} Gekoppelde.",
  nfc_linking_failed: "NFC-tag kan niet worden gekoppeld. Probeer het opnieuw.",
  nfc_not_enabled: "NFC wordt niet ondersteund door dit apparaat of is uitgeschakeld.",
  nfc_initialization_failed: "Helaas is er iets misgegaan. Probeer het opnieuw.",
  nfc_scan_failed: "Helaas is er iets misgegaan. Probeer het opnieuw.",
  nfc_no_tag_found: "Er is geen NFC-tag gevonden.",
  nfc_tag_already_linked_to: "Deze NFC-tag is al verkrijgbaar bij {name} Gekoppelde.",
  nfc_scan_active: "NFC-scan actief",
  nfc_linking_enabled: "NFC-tags kunnen nu worden gekoppeld. Houd de NFC-tag vast om nu aan de NFC-lezer te koppelen.",
  nfc_all_employees_linked: "Alle medewerkers die aan dit apparaat zijn toegewezen, zijn al gekoppeld.",
  no_employee_to_nfc_warning: "Voor deze NFC-tag kon geen medewerker worden gevonden.",
  select_employee_to_link_nfc: "Aan wie moet de NFC-tag worden gekoppeld?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Welkom bij Clockin",
        clocking_time: "Baantijden",
        push_notifications: "Vergeet niets"
      },
      text: {
        clocking_time: "De klok is je startpunt voor elke activiteit. Jij doet je werk, de app doet de documentatie.",
        push_notifications: "Zet nu meldingen aan. Clockin herinnert je eraan als je een stempel vergeet en zorgt ervoor dat je alles wat belangrijk is meteen krijgt."
      },
      button: {
        lets_go: "Nu aan de slag"
      }
    },
    my_area: {
      heading: {
        my_area: "Mijn gebied",
        absences: "Afwezigheden en sollicitaties",
        settings: "Persoonlijke instellingen"
      },
      text: {
        my_area: "De centrale plek waar je direct een overzicht hebt van je werktijden en overuren. Van hieruit kun je je werktijden beheren, je dagelijkse logboek bekijken, aanvragen indienen en je tijden bekijken.",
        absences: "Beheer vakantieaanvragen, ziektedagen en andere afwezigheden. Houd altijd de status van je aanvragen bij en dien snel en eenvoudig nieuwe aanvragen in met slechts een paar klikken.",
        settings: "Stuur berichten naar het bedrijf of wijzig je persoonlijke instellingen en als je je wachtwoord wilt wijzigen, kun je dat hier ook doen!"
      },
      button: {
        lets_go: "Begin"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Omdat jouw tijd telt",
        clock_in: "Stempel in",
        switch_task: "Postzegel veranderen",
        clock_out: "Stamp eruit",
        thats_it: "Dat is het!"
      },
      text: {
        your_time_matters: "Met clockin helpen we je om je te concentreren op het belangrijkste. Registreer je werktijd met slechts één klik.",
        clock_in: "Met één klik ben je direct ingeklokt. Clockin slaat je gegevens automatisch op en je hebt altijd alles in beeld.",
        switch_task: "Heb je een ander project, neem je een pauze of ga je naar je volgende afspraak? Stempel jezelf gewoon opnieuw af op je nieuwe activiteit. De rest wordt automatisch geregistreerd.",
        clock_out: "En met één klik ben je uitgestempeld.",
        thats_it: "Je hebt het gedaan en bent klaar om je werktijd te registreren. Als je hulp nodig hebt, neem dan gewoon contact met ons op. Alles is gemakkelijk met clockin - inclusief de communicatie met ons."
      },
      button: {
        your_time_matters: "Laat me zien hoe het moet",
        thats_it: "Nu aan de slag"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Omdat jouw tijd telt",
        clock_in: "Stempel in",
        clock_in_team: "Check in team",
        switch_task: "Postzegel veranderen",
        change_teamleader: "Eenheid overhandigen",
        clock_out: "Stamp eruit",
        thats_it: "Dat is het!"
      },
      text: {
        your_time_matters: "Met clockin helpen we je om je te concentreren op de essentie. Registreer de werktijden van je team met slechts één klik.",
        clock_in: "Selecteer een persoon die inklokt voor het team en met één klik ben je direct ingeklokt. clockin slaat je gegevens automatisch op en je kunt altijd alles in de gaten houden.",
        clock_in_team: "Geef je team gewoon rechtstreeks een stempel. Allemaal tegelijk of alleen individuele leden.",
        switch_task: "Heb je een ander project, neem je een pauze of reis je naar je volgende afspraak? Stempel gewoon je nieuwe activiteit. De rest wordt automatisch geregistreerd.",
        change_teamleader: "Ben je klaar met werken, moet je weg of klok je niet meer in voor het team? Geef het apparaat gewoon af in de app en alles gaat weer normaal.",
        clock_out: "En met één klik zijn jij en je team uitgeklokt. Natuurlijk kun je ook individuele leden op elk moment uitklokken.",
        thats_it: "Je hebt het gedaan en bent klaar om de werktijd voor je team te registreren. Als je hulp nodig hebt, neem dan gewoon contact met ons op. Alles is eenvoudig met Clockin - inclusief de communicatie met ons."
      },
      button: {
        your_time_matters: "Laat me zien hoe het moet",
        thats_it: "Nu aan de slag"
      }
    },
    my_area: {
      heading: {
        welcome: "Welkom in uw omgeving",
        my_area: "Mijn gebied",
        create_time: "Tijd creëren",
        change_time: "Juiste tijd",
        absences: "Afwezigheden en sollicitaties",
        settings: "Persoonlijke instellingen",
        thats_it: "Dat is het!"
      },
      text: {
        welcome: "Ontdek nog meer manieren om je werktijd efficiënt en gemakkelijk te beheren. Laten we eens naar jouw gebied kijken.",
        my_area: "De centrale plek waar je direct een overzicht hebt van je werktijden en overuren. Van hieruit kun je je werktijden beheren, je dagelijkse logboek bekijken, aanvragen indienen en je tijden bekijken.",
        create_time: "Ben je een tijd vergeten in te voeren of wil je later tijden toevoegen? Geen probleem! Voeg ontbrekende tijden toe, registreer pauzes en houd je werktijdaccount up-to-date.",
        change_time: "Wil je je tijden corrigeren? Geen probleem! Met clockin kun je eenvoudig onjuiste tijden corrigeren en aanpassen.",
        absences: "Beheer vakantieaanvragen, ziektedagen en andere afwezigheden. Houd altijd de status van je aanvragen bij en dien snel en eenvoudig nieuwe aanvragen in met slechts een paar klikken.",
        settings: "Stuur berichten naar het bedrijf of wijzig je persoonlijke instellingen en als je je wachtwoord wilt wijzigen, kun je dat hier ook doen!",
        thats_it: "Het is je gelukt! Nu kun je moeiteloos je tijd beheren, afwezigheden organiseren en je concentreren op wat belangrijk is: je werk. Veel succes met je productieve tijd!"
      },
      button: {
        welcome: "Laat me zien hoe het moet",
        thats_it: "Nu aan de slag"
      }
    },
    clock: {
      clockin_now: "Nu vergrendelen",
      clock_your_first_time_now: "& neem je eerste keer op"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Bedankt voor het gebruik van clockin!",
      question: "Hoe waarschijnlijk is het dat u Clockin zult aanbevelen aan vrienden of collega's?",
      very_likely: "Zeer waarschijnlijk",
      very_unlikely: "Zeer onwaarschijnlijk",
      help_us_improve: "Hoe kunnen we clockin voor jou verbeteren?",
      what_do_you_agree_with: "Met welke beweringen ben je het eens?",
      choose_three_statements: "Kies maximaal drie uitspraken.",
      hard_to_use: "Moeilijk te bedienen",
      lacking_features: "Te weinig functies",
      does_not_help_me: "maakt mijn werkdag er niet eenvoudiger op",
      confusing: "verwarrend",
      poorly_implemented: "Slecht geïmplementeerde functies",
      too_buggy: "te foutgevoelig",
      too_slow: "lange laadtijden",
      what_else: "Is er nog iets dat je ons wilt vertellen?",
      can_we_ask_you_a_few_questions: "Mogen we je nog een paar vragen stellen?",
      how_happy_are_you_with_the_introduction_of_clockin: "Hoe blij bent u met de invoering van clockin in uw bedrijf?",
      how_much_do_you_enjoy_using_clockin: "Hoe vind je het om clockin te gebruiken?",
      how_much_easier_does_clockin_make_your_work: "In hoeverre maakt het inklokken je dagelijks werk gemakkelijker?",
      how_happy_are_you_with_the_following_aspects: "Hoe tevreden ben je met de volgende punten?",
      clarity_of_the_app: "Duidelijkheid van de app",
      simplicity_of_use: "Eenvoudige bediening",
      app_features: "Functies in de app",
      feedback_received: "We hebben uw feedback ontvangen. Bedankt voor uw tijd.",
      thanks_for_taking_the_time: "Bedankt dat je de tijd hebt genomen.",
      what_can_we_do_to_improve: "Kun je ons meer vertellen over je ervaring, zodat we het de volgende keer nog beter kunnen doen?",
      what_can_we_do_to_get_it_right: "Kunt u ons meer vertellen over uw ervaring, zodat we het de volgende keer goed kunnen doen?",
      comment_placeholder: "Uw bericht"
    }
  },
  travel_logs: {
    add: "Reisgegevens toevoegen",
    edit: "Reisgegevens bewerken",
    saving: "Reisgegevens worden opgeslagen...",
    saved_successfully: "Reisgegevens succesvol opgeslagen!",
    unable_to_save: "Helaas is dat niet gelukt 😢"
  },
  attach_file: "Bestand bijvoegen",
  image_to_text: {
    info: "Zorg ervoor dat de tekst duidelijk herkenbaar is en volledig op de afbeelding te zien is.",
    attach_image: "Foto bijvoegen",
    processing: "Je tekst wordt ingelezen.",
    processing_failed: "Helaas werkte het importeren niet 😢",
    no_text_found: "Er kon geen tekst worden herkend."
  },
  correction_enter_reason: "Geef een reden voor de correctie.",
  daily_notes: {
    add: "Schrijf een notitie",
    edit: "Opmerking bewerken",
    saving: "Notitie is opgeslagen...",
    saved_successfully: "Opmerking succesvol opgeslagen!",
    unable_to_save: "Helaas is dat niet gelukt 😢",
    no_notes_yet: "Geen notitie gemaakt",
    create_note: "Maak"
  },
  calendar_sync: {
    title: "Planning synchroniseren",
    description: "Synchroniseer je werkschema met een kalender en houd oude en nieuwe afspraken in de gaten.",
    url: "Adres in iCal-formaat",
    url_description: "Je kunt dit adres gebruiken om toegang te krijgen tot deze agenda vanuit andere applicaties.",
    note: "Tip",
    note_description: "Bij sommige kalenders kan het tot 24 uur duren voordat nieuwe afspraken worden weergegeven.",
    sync_now: "Agenda synchroniseren",
    copied: "Kalender url gekopieerd."
  },
  registration: {
    skip_all: "Alles overslaan",
    already_signed_up: "Ik heb al een account",
    title_1: "Laten we beginnen! Welke tijden wil je opnemen met clockin?",
    description_1: "Laat ons clockin voor u op maat maken",
    option_1_a: "Algemene werktijd (komen, gaan & pauze)",
    option_1_b: "Project werktijden",
    title_2: "Wil je het documenteren?",
    description_2: "Aan welke vereisten moet hiervoor worden voldaan?",
    option_2_a: "Foto's",
    option_2_b: "Schetsen",
    option_2_c: "Opmerking functie",
    option_2_d: "Checklists en formulieren",
    option_2_e: "Digitale projectbestanden",
    title_3: "Wat zou je nog meer willen digitaliseren?",
    description_3: "Er is nog veel meer te ontdekken bij clockin, misschien zit er wel iets voor je bij.",
    option_3_a: "Vakantie",
    option_3_b: "Ziektes en afwezigheden",
    option_3_c: "Digitaal personeelsdossier",
    option_3_d: "Bedrijfsanalyse",
    option_3_e: "Inzetplanning",
    option_3_f: "Belastingadviseur gegevensoverdracht (DATEV)",
    title_4: "In welke sector is uw bedrijf actief?",
    description_4: "We willen je beter leren kennen zodat we clockin beter kunnen afstemmen op jouw behoeften.",
    option_4_a: "diensten",
    option_4_b: "Ambacht",
    option_4_c: "Gezondheid en welzijn",
    option_4_d: "Inkoop, bestellingen en handel",
    option_4_e: "Hotel en catering",
    option_4_f: "Auto, transport & machines",
    option_4_g: "Andere industrie",
    title_5: "Hoeveel werknemers telt uw bedrijf?",
    description_5: "Met het aantal werknemers kunnen we het inklokken aanpassen aan de grootte van je bedrijf.",
    title_6: "Super! Je klok is nu ingesteld",
    description_6: "We hebben alleen je naam nodig.",
    input_6_a: "Bedrijf",
    input_6_b: "Voornaam",
    input_6_c: "Achternaam",
    input_6_d: "Telefoonnummer",
    title_7: "Je bent er klaar voor! Probeer clockin 14 dagen gratis!",
    input_7_a: "Uw e-mailadres",
    description_7: "Naar welk e-mailadres moeten we je wachtwoord sturen?",
    input_7_b: "Zo werd ik me bewust van",
    how_did_you_hear_about_clockin: "Hoe heb je voor het eerst van Clockin gehoord?",
    recommendation_option_1: "Aanbeveling",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Zoeken op internet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Vergelijkingsplatform",
    recommendation_option_7: "Tijdschriften & online artikelen",
    known_from: "Bekend van",
    agb_1: "Door het formulier te verzenden, accepteert u de ",
    agb_2: 'AGB',
    agb_3: " en de ",
    agb_4: "Privacybeleid",
    start: 'Test starten',
    validation_failed: "Vul alle velden correct in."
  },
  clocki: {
    listening_heading: "Ik luister naar je",
    listening_subtext: "Hoe kan ik je helpen?",
    hi_0: "Hallo, hoe kan ik u helpen?",
    hi_1: "Hé, hoe kan ik je helpen?",
    hi_2: "Hallo, hoe kan ik u helpen?",
    hi_3: "Moin moin, wat kan ik voor je doen?",
    hi_4: "Hallo, wat kan ik voor u doen?",
    hi_5: "Hallo, hoe kan ik u helpen?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Helaas lijkt spraakherkenning niet te werken op je apparaat",
    microphone_permission_denied: "Helaas heb ik geen toegang tot uw microfoon. Controleer de autorisaties in de instellingen zodat ik je kan horen.",
    please_speak: "Je kunt nu met Clocki praten",
    create_activity: "Maak een activiteit aan",
    modify_activity: "Activiteit wijzigen",
    delete_activity: "Activiteit verwijderen",
    create_daily_note: "Een dagelijkse notitie maken",
    search_project: "Zoeken naar een project",
    note_copied: "Notitie gekopieerd",
    create_absence_request: "Afwezigheid aanvragen",
    delete_absence: "Afwezigheid verwijderen",
    confirm_deletion: "Weet u zeker dat uw {activity_label} Stempelen van {date} klok moet worden verwijderd?",
    confirm_absence_deletion: "Weet u zeker dat uw aanvraag voor {category} van de {startDate} totdat {endDate} Wil je verwijderen?",
    task_before_modification: "Voor: {task}",
    starts_at_before_modification: "Starttijd vóór: {startsAt}",
    ends_at_before_modification: "Eindtijd vóór: {endsAt}",
    something_went_wrong: "Er is iets misgegaan. Probeer het later nog eens.",
    was_this_helpful: "Kan Clocki je helpen?",
    actions: {
      CREATE_ABSENCE: {
        title: "Afwezigheid bevestigen"
      },
      CREATE_DAILY_NOTE: {
        title: "Maak nu een notitie",
        daily_notes_disabled: "Helaas is de notitiefunctie uitgeschakeld. Vraag je beheerder om de functie te activeren in het Office Center.",
        success: "Notitie succesvol opgeslagen in het dagelijkse logboek 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Maak nu documentatie",
        created_by_clocki: "Gemaakt met Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Open nu \"Mijn tijden"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Open nu \"Mijn gebied"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Open nu \"Wachtwoord wijzigen"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Stempel \"werktijd\" nu",
        PAUSE: "Stempel \"Pauze\" nu",
        DRIVING_TIME: "Stempel \"reistijd\" nu",
        LOGOUT: "Nu ontgrendelen"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Gebruik je Clockin graag?"
  },
  translation_failed: "Helaas werkte 😕 de vertaling niet",
  video_transcript_not_available: "Geen transcript beschikbaar",
  video_upload_succeeded: "Video-upload voltooid.",
  video_upload_failed: "Video-upload mislukt.",
  video_send_failed: "De video kon op dit moment niet worden uitgezonden. We proberen het later nog eens.",
  uploading_video: "Video uploaden...",
  language_selection_header: "Taal selecteren",
  language_selection_message: "Kies je voorkeurstaal",
  shifts: {
    my_shifts: "Mijn diensten",
    free_shifts: "Vrije diensten",
    next_shift: "Je volgende dienst",
    shift_not_found: "Geen lagen gevonden",
    show_shift_plan: "Bekijk dit dienstrooster",
    no_shift_place: "Geen locatie vermeld",
    no_shifts_assigned: "Je bent momenteel niet toegewezen aan een dienst",
    free_shifts_unavailable: "Vrije diensten zijn momenteel niet beschikbaar",
    filter_shift_plans: "Filterverschuivingschema's",
    no_shift_plans_available: "Geen dienstroosters beschikbaar",
    filter_locations: "Filterplaatsen",
    no_locations_available: "Geen plaatsen beschikbaar",
    no_plan_selected: "Geen dienstrooster geselecteerd",
    no_shifts_for_plan: "Er zijn geen lagen gevonden voor dit plan",
    no_shifts_for_location: "Geen diensten gevonden voor de geselecteerde locatie",
    unknown_shift_plan: "Onbekend dienstrooster",
    unknown_location: "Onbekende locatie",
    loading_more_shifts: "Meer lagen laden..."
  },
  clockin_reminder_title: "Ben je al aan het werk? 🔔",
  clockin_reminder: "Vergeet niet in te klokken.",
  clockout_reminder_title: "Ben je al aan het eind van de dag? 🔔",
  clockout_reminder: "Vergeet niet uit te klokken.",
  choose_clockin_reminder_time: "Tijd voor inklokherinnering",
  choose_clockout_reminder_time: "Tijd voor uitklokherinnering",
  choose_break_reminder_time: "Pauzeduur",
  saved_successfully: "Succesvol gered 👍",
  clock_reminder_channel_name: "Postzegelherinneringen",
  clock_reminder_channel_description: "Herinneringen om in en uit te klokken",
  break_reminder_title: "Neem je nog steeds pauze? ⏰",
  break_reminder: "Opmerking: Je pauze loopt nog steeds.",
  // Video component translations
  video_not_supported: "Je apparaat ondersteunt de video niet :/",
  video_loading_error: "Fout laden video",
  video_retry: "Herladen"
};